import { render } from "./LanguageEdit.vue?vue&type=template&id=6fe20ed3"
import script from "./LanguageEdit.vue?vue&type=script&lang=js"
export * from "./LanguageEdit.vue?vue&type=script&lang=js"
script.render = render

export default script